import script from "./appConfigLeft.vue?vue&type=script&setup=true&lang=ts"
export * from "./appConfigLeft.vue?vue&type=script&setup=true&lang=ts"

import "./appConfigLeft.vue?vue&type=style&index=0&id=5aa6d60f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa6d60f"]])

export default __exports__